"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@dbi-tools/ui-kit/");

var _modal = require("@dbi-tools/ui-kit/lib/modal");

var _delivery = _interopRequireDefault(require("@dbi-tools/ui-kit/lib/icons/delivery"));

var _other = require("../../../helpers/other");

var _useMedia = require("../../../hooks/use-media");

var _const = require("../../../const");

var _colorCircle = _interopRequireDefault(require("../../color-circle"));

var _types = require("../types");

var _colorChartModal = require("./color-chart-modal.styled");

var _helpers = require("../../../helpers");

var _utils = require("@dbi-tools/ui-kit/lib/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ColorChartModal = function ColorChartModal(props) {
  var _props$colors = props.colors,
      colors = _props$colors === void 0 ? [] : _props$colors,
      activeColor = props.activeColor,
      onCloseHandle = props.onCloseHandle;
  var COLOR_CHART_ID = 'color-chart-modal-id';
  var IS_OPEN = 'is-open';
  var IS_RENDERED = 'is-rendered';
  if (!(0, _utils.isNumber)(activeColor)) return null;
  var isMobile = (0, _useMedia.useMedia)(_const.Breakpoints.MOBILE);
  (0, _react.useEffect)(function () {
    var test = document.getElementById(COLOR_CHART_ID);
    if (!test) return;
    setTimeout(function () {
      test.classList.add(IS_RENDERED);
    }, 100);
    setTimeout(function () {
      test.classList.add(IS_OPEN);
    }, 200);
  }, []);
  var _colors$activeColor = colors[activeColor],
      fileReference = _colors$activeColor.fileReference,
      hexValue = _colors$activeColor.hexValue,
      altText = _colors$activeColor.altText,
      name = _colors$activeColor.name,
      _colors$activeColor$p = _colors$activeColor.popupLinks,
      popupLinks = _colors$activeColor$p === void 0 ? [] : _colors$activeColor$p,
      _colors$activeColor$p2 = _colors$activeColor.popupButtons,
      popupButtons = _colors$activeColor$p2 === void 0 ? [] : _colors$activeColor$p2;
  return /*#__PURE__*/_react.default.createElement(_colorChartModal.ColorChartModalStyled, {
    id: COLOR_CHART_ID
  }, /*#__PURE__*/_react.default.createElement(_modal.Modal, {
    onClose: function onClose() {
      var test = document.getElementById(COLOR_CHART_ID);

      if (isMobile) {
        test.classList.remove(IS_OPEN);
        setTimeout(function () {
          onCloseHandle();
        }, 100);
      } else {
        onCloseHandle();
      }
    },
    isOpen: true
  }, /*#__PURE__*/_react.default.createElement(_modal.Modal.Header, null, /*#__PURE__*/_react.default.createElement(_colorChartModal.ColorChartModalCircle, null, /*#__PURE__*/_react.default.createElement(_uiKit.Box, null, /*#__PURE__*/_react.default.createElement(_colorCircle.default, {
    hexValue: hexValue,
    fileReference: fileReference,
    altText: altText
  })), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    as: "span",
    mt: 0,
    mb: 0,
    ml: 15,
    align: "left"
  }, name))), /*#__PURE__*/_react.default.createElement(_modal.Modal.Body, null, /*#__PURE__*/_react.default.createElement(_uiKit.Row, null, /*#__PURE__*/_react.default.createElement(_uiKit.Col, {
    xs: 12,
    md: 5
  }, popupButtons && !!popupButtons.length && popupButtons.map(function (_ref, index) {
    var link = _ref.link,
        text = _ref.text,
        type = _ref.type,
        buttonColor = _ref.buttonColor;
    var _ColorChartButtonsPro = _types.ColorChartButtonsProps[buttonColor || _types.ColorChartButtonColor.CLARET],
        variant = _ColorChartButtonsPro.variant,
        color = _ColorChartButtonsPro.color;
    return /*#__PURE__*/_react.default.createElement(_colorChartModal.ColorChartModalButtonWrapp, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
      as: "a",
      variant: buttonColor ? variant : (0, _helpers.getButtonStyleByType)(type),
      color: color,
      href: link,
      fullWidth: true,
      target: (0, _other.isExternalLink)(link) ? '_blank' : '_self'
    }, text));
  }), /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_delivery.default, {
    measure: 20,
    color: "success"
  }), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    as: "span",
    color: "success",
    align: "center",
    measure: "xs",
    ml: 10,
    fontWeight: "light"
  }, "Free shipping on color swatches"))), /*#__PURE__*/_react.default.createElement(_uiKit.Col, {
    xs: 12,
    md: 7
  }, /*#__PURE__*/_react.default.createElement(_colorChartModal.ColorChartModalLinksWrap, null, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    uppercase: true,
    measure: "xs",
    fontWeight: "bold",
    mb: -5,
    mt: 0
  }, "exclusive Collections"), /*#__PURE__*/_react.default.createElement(_colorChartModal.ColorChartModalLinks, null, popupLinks.map(function (_ref2, index) {
    var link = _ref2.link,
        text = _ref2.text;
    return /*#__PURE__*/_react.default.createElement(_colorChartModal.ColorChartModalLinksItem, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
      as: "a",
      href: link,
      color: "gray800",
      variant: "underlined",
      measure: "sm",
      target: (0, _other.isExternalLink)(link) ? '_blank' : '_self'
    }, text));
  }))))))));
};

var _default = ColorChartModal;
exports.default = _default;